<template>
  <div class="centralizadohorizontal">
    <div class="estiloColuna">
      <v-card elevation="2" outlined style="margin-top:1%;height:95%;overflow-y:auto;">

        <v-card-title class="pb-1 pt-3" style="font-size:1.25rem;">
          <v-icon left color="primary">mdi-link-variant</v-icon>
          Associação de Produtos Omie
          <v-spacer />
          <v-btn outlined small color="primary" :loading="sincronizando" :disabled="sincronizando" @click="sincronizarAgora" style="font-size:0.75rem;">
            <v-icon left small>mdi-sync</v-icon>
            Sincronizar agora
          </v-btn>
        </v-card-title>
        <v-card-subtitle class="pb-2" style="margin-top:3px;">
          Vincule produtos do cardápio ao catálogo Omie para sincronização de estoque
        </v-card-subtitle>

        <v-divider />

        <v-tabs v-model="tab" color="primary" @change="onTabChange">
          <v-tab>
            Pendentes
            <v-chip v-if="pendentes.length" x-small color="warning" text-color="white" class="ml-2">{{ pendentes.length }}</v-chip>
          </v-tab>
          <v-tab>
            Com erro
            <v-chip v-if="comErro.length" x-small color="error" text-color="white" class="ml-2">{{ comErro.length }}</v-chip>
          </v-tab>
          <v-tab>Todos os produtos</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">

          <!-- Tab: Pendentes -->
          <v-tab-item>
            <v-data-table
              :headers="headersPendentes"
              :items="pendentes"
              :loading="carregando"
              item-key="idproduto"
              no-data-text="Nenhum produto pendente de associação"
            >
              <template v-slot:item.acoes="{ item }">
                <div class="d-flex align-center" style="gap:8px;padding:6px 0;min-width:340px;">
                  <v-autocomplete
                    v-model="buscaState[item.idproduto].codSelecionado"
                    :items="buscaState[item.idproduto].resultados"
                    :loading="buscaState[item.idproduto].buscando"
                    item-value="codigo_produto"
                    item-text="descricao"
                    placeholder="Buscar produto Omie..."
                    dense
                    outlined
                    hide-details
                    hide-no-data
                    clearable
                    style="max-width:280px;"
                    @update:search-input="val => setTermo(item.idproduto, val)"
                    @keyup.enter="buscarProdutosOmie(item.idproduto)"
                  >
                    <template v-slot:append>
                      <v-icon style="cursor:pointer" color="primary" @click="buscarProdutosOmie(item.idproduto)">mdi-magnify</v-icon>
                    </template>
                    <template v-slot:item="{ item: r }">
                      <v-list-item-content>
                        <v-list-item-title>{{ r.descricao }}</v-list-item-title>
                        <v-list-item-subtitle>Cód. {{ r.codigo_produto }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                  <v-btn
                    color="success"
                    :disabled="!buscaState[item.idproduto].codSelecionado"
                    @click="associar(item)"
                    style="min-height:40px;font-size:0.75rem;"
                  >
                    <v-icon left small>mdi-link</v-icon>
                    Associar
                  </v-btn>
                </div>
              </template>
            </v-data-table>
          </v-tab-item>

          <!-- Tab: Com erro -->
          <v-tab-item>
            <v-data-table
              :headers="headersErro"
              :items="comErro"
              :loading="carregando"
              item-key="idproduto"
              no-data-text="Nenhum produto com erro de sincronização"
            >
              <template v-slot:item.acoes="{ item }">
                <div class="d-flex align-center" style="gap:8px;padding:6px 0;min-width:340px;">
                  <v-autocomplete
                    v-model="buscaState[item.idproduto].codSelecionado"
                    :items="buscaState[item.idproduto].resultados"
                    :loading="buscaState[item.idproduto].buscando"
                    item-value="codigo_produto"
                    item-text="descricao"
                    placeholder="Buscar produto Omie..."
                    dense
                    outlined
                    hide-details
                    hide-no-data
                    clearable
                    style="max-width:260px;"
                    @update:search-input="val => setTermo(item.idproduto, val)"
                    @keyup.enter="buscarProdutosOmie(item.idproduto)"
                  >
                    <template v-slot:append>
                      <v-icon style="cursor:pointer" color="primary" @click="buscarProdutosOmie(item.idproduto)">mdi-magnify</v-icon>
                    </template>
                    <template v-slot:item="{ item: r }">
                      <v-list-item-content>
                        <v-list-item-title>{{ r.descricao }}</v-list-item-title>
                        <v-list-item-subtitle>Cód. {{ r.codigo_produto }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                  <v-btn
                    color="warning"
                    :disabled="!buscaState[item.idproduto].codSelecionado"
                    @click="associar(item)"
                    style="height:40px;"
                  >
                    <v-icon left small>mdi-link-variant</v-icon>
                    Re-associar
                  </v-btn>
                </div>
              </template>
            </v-data-table>
          </v-tab-item>

          <!-- Tab: Todos os produtos -->
          <v-tab-item>
            <div class="d-flex flex-wrap align-center" style="gap:12px;padding:12px 16px;">
              <v-select
                v-model="filtros.controla_estoque"
                :items="opcoesControlaEstoque"
                label="Controle de estoque"
                clearable
                dense
                outlined
                hide-details
                style="max-width:200px;"
                @change="getProdutosEstoque"
              />
              <v-select
                v-model="filtros.status_sincronizacao_omie"
                :items="statusOptions"
                item-text="label"
                item-value="valor"
                label="Status"
                clearable
                dense
                outlined
                hide-details
                style="max-width:200px;"
                @change="getProdutosEstoque"
              />
              <v-btn outlined @click="getProdutosEstoque" :loading="carregandoProdutos" style="height:40px;">
                <v-icon left>mdi-refresh</v-icon>
                Atualizar
              </v-btn>
            </div>

            <v-data-table
              :headers="headersTodos"
              :items="todosProdutos"
              :loading="carregandoProdutos"
              item-key="idproduto"
              dense
              no-data-text="Nenhum produto encontrado"
            >
              <template v-slot:item.controla_estoque="{ item }">
                <v-switch
                  v-model="item.controla_estoque"
                  dense
                  hide-details
                  class="mt-0 pt-0"
                  @change="val => toggleControlaEstoque(item, val)"
                />
              </template>
              <template v-slot:item.status_sincronizacao_omie="{ item }">
                <v-chip x-small :color="corStatus(item.status_sincronizacao_omie)" text-color="white">
                  {{ labelStatus(item.status_sincronizacao_omie) }}
                </v-chip>
              </template>
              <template v-slot:item.estoque_omie_atual="{ item }">
                <span :class="estoqueAbaixoMinimo(item) ? 'error--text font-weight-bold' : ''">
                  <v-icon v-if="estoqueAbaixoMinimo(item)" x-small color="error" class="mr-1">mdi-alert</v-icon>
                  {{ item.estoque_omie_atual != null ? item.estoque_omie_atual : '—' }}
                </span>
              </template>
              <template v-slot:item.estoque_sincronizado_em="{ item }">
                <span class="caption text--secondary">{{ formatarData(item.estoque_sincronizado_em) }}</span>
              </template>
            </v-data-table>
          </v-tab-item>

        </v-tabs-items>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AssociacaoOmie',
  data () {
    return {
      tab: 0,
      carregando: false,
      carregandoProdutos: false,
      sincronizando: false,
      pendentes: [],
      comErro: [],
      todosProdutos: [],
      statusOptions: [],
      buscaState: {},
      filtros: {
        controla_estoque: null,
        status_sincronizacao_omie: null,
      },
      opcoesControlaEstoque: [
        { text: 'Com controle ativo', value: 'true' },
        { text: 'Sem controle', value: 'false' },
      ],
      headersPendentes: [
        { text: 'ID', value: 'idproduto', width: '80px' },
        { text: 'Produto interno', value: 'descproduto' },
        { text: 'CD', value: 'nomecd' },
        { text: 'Buscar / Associar', value: 'acoes', sortable: false }
      ],
      headersErro: [
        { text: 'ID', value: 'idproduto', width: '80px' },
        { text: 'Produto interno', value: 'descproduto' },
        { text: 'CD', value: 'nomecd' },
        { text: 'Cód. Omie', value: 'cod_produto_omie', width: '120px' },
        { text: 'Buscar / Re-associar', value: 'acoes', sortable: false }
      ],
      headersTodos: [
        { text: 'ID', value: 'idproduto', width: '80px' },
        { text: 'Produto interno', value: 'descproduto' },
        { text: 'CD', value: 'nomecd' },
        { text: 'Cód. Omie', value: 'cod_produto_omie', width: '120px' },
        { text: 'Controle', value: 'controla_estoque', sortable: false, width: '100px' },
        { text: 'Estoque atual', value: 'estoque_omie_atual', width: '120px' },
        { text: 'Mínimo', value: 'estoque_minimo_omie', width: '90px' },
        { text: 'Status', value: 'status_sincronizacao_omie', width: '160px' },
        { text: 'Sincronizado em', value: 'estoque_sincronizado_em' },
      ]
    }
  },
  created () {
    this._termos = {}
  },
  mounted () {
    this.$store.dispatch('set_titulo', 'Associação Omie')
    this.getPendencias()
    this.getStatusOptions()
  },
  methods: {
    onTabChange (tab) {
      if (tab === 2 && this.todosProdutos.length === 0) {
        this.getProdutosEstoque()
      }
    },
    async getPendencias () {
      this.carregando = true
      try {
        const response = await this.$http.get('pdv/omie/pendencias')
        const { pendentes, comErro } = response.data
        this.pendentes = pendentes || []
        this.comErro = comErro || []
        ;[...this.pendentes, ...this.comErro].forEach(p => {
          if (!this.buscaState[p.idproduto]) {
            this.$set(this.buscaState, p.idproduto, { resultados: [], buscando: false, codSelecionado: null })
          }
        })
      } catch (error) {
        console.log(error)
        this.$alertar('warning', 'Não foi possível carregar as pendências de associação Omie', '=(')
      } finally {
        this.carregando = false
      }
    },
    async getStatusOptions () {
      try {
        const response = await this.$http.get('pdv/omie/statusSincronizacao')
        this.statusOptions = response.data
      } catch (e) {
        // silencioso
      }
    },
    async getProdutosEstoque () {
      this.carregandoProdutos = true
      try {
        const params = {}
        if (this.filtros.controla_estoque != null) params.controla_estoque = this.filtros.controla_estoque
        if (this.filtros.status_sincronizacao_omie) params.status_sincronizacao_omie = this.filtros.status_sincronizacao_omie
        const response = await this.$http.get('pdv/omie/produtosEstoque', { params })
        this.todosProdutos = response.data
      } catch (e) {
        this.$alertar('warning', 'Erro ao carregar produtos', '=(')
      } finally {
        this.carregandoProdutos = false
      }
    },
    async toggleControlaEstoque (item, novoValor) {
      const valorAnterior = !novoValor
      try {
        await this.$http.put('pdv/produto/cadastro', { idproduto: item.idproduto, descproduto: item.descproduto, controla_estoque: novoValor })
        this.$alertar('success', novoValor ? 'Controle ativado' : 'Controle desativado', '=)')
      } catch (e) {
        item.controla_estoque = valorAnterior
        this.$alertar('warning', 'Erro ao atualizar', '=(')
      }
    },
    setTermo (idproduto, val) {
      this._termos[idproduto] = val || ''
    },
    async buscarProdutosOmie (idproduto) {
      const state = this.buscaState[idproduto]
      if (!state) return
      const termo = this._termos[idproduto] || ''
      if (!termo) { state.resultados = []; return }
      state.buscando = true
      try {
        const response = await this.$http.get('pdv/omie/buscarProdutos', { params: { termo } })
        state.resultados = response.data || []
      } catch (e) {
        this.$alertar('warning', 'Erro na busca Omie', '=(')
      } finally {
        state.buscando = false
      }
    },
    async sincronizarAgora () {
      this.sincronizando = true
      try {
        await this.$http.post('pdv/omie/sincronizarAgora')
        this.$alertar('success', 'Sincronização iniciada', '=)')
        await this.getPendencias()
      } catch (e) {
        this.$alertar('warning', 'Erro ao sincronizar', '=(')
      } finally {
        this.sincronizando = false
      }
    },
    async associar (item) {
      const state = this.buscaState[item.idproduto]
      if (!state.codSelecionado) { this.$alertar('warning', 'Selecione um produto Omie', ''); return }
      try {
        await this.$http.post('pdv/omie/associarProduto', { idproduto: item.idproduto, cod_produto_omie: state.codSelecionado })
        this.$alertar('success', 'Produto associado', '=)')
        this.$set(this.buscaState, item.idproduto, { resultados: [], buscando: false, codSelecionado: null })
        this._termos[item.idproduto] = ''
        await this.getPendencias()
      } catch (e) {
        this.$alertar('warning', 'Erro ao associar produto', '=(')
      }
    },
    estoqueAbaixoMinimo (item) {
      return item.estoque_omie_atual != null && item.estoque_minimo_omie != null && item.estoque_omie_atual <= item.estoque_minimo_omie
    },
    formatarData (v) {
      if (!v) return '—'
      const d = new Date(v)
      if (isNaN(d)) return v
      return d.toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
    },
    corStatus (status) {
      const cores = { OK: 'success', ERRO: 'error', PENDENTE_ASSOCIACAO: 'warning' }
      return cores[status] || 'grey'
    },
    labelStatus (status) {
      const op = this.statusOptions.find(s => s.valor === status)
      return op ? op.label : (status || '—')
    },
  }
}
</script>

<style scoped>
</style>
